import 'reflect-metadata';
import { Currency } from '@order-mage/integration-sdk';
import { ComponentType } from 'react';
import {
    /*Al,Ba,Be,Bg,Ca,Cy,*/ Cz,
    /*,De,Dk,Ee,Es,Fi,Fr,Ga,*/ Gb,
    /*Gl,Gr,Hr,Hu,Is,It,Lt,Lv,Mk,Mt,Nl,No,Pl,Pt,Ro,Rs,Ru,Se,Si,*/ Sk /*Tr,Ua*/,
    Us,
} from 'react-flags-select';
import { Language } from '@/shared/model/Language';

export enum TranslationLanguage {
    EN_GB = 'en-GB',
    EN_US = 'en-US',
    CS = 'cs',
    SK = 'sk',
}

export const languageTranslationLanguageMap: Partial<Record<Language, TranslationLanguage>> = {
    [Language.EN_GB]: TranslationLanguage.EN_GB,
    [Language.EN_US]: TranslationLanguage.EN_GB,
    [Language.CS]: TranslationLanguage.CS,
    [Language.SK]: TranslationLanguage.SK,
};

export const languageTranslationMap: Record<TranslationLanguage, Language> = {
    [TranslationLanguage.EN_GB]: Language.EN_GB,
    [TranslationLanguage.EN_US]: Language.EN_GB,
    [TranslationLanguage.CS]: Language.CS,
    [TranslationLanguage.SK]: Language.SK,
};

export const languageCurrencyMap: Partial<Record<TranslationLanguage, Currency>> = {
    [TranslationLanguage.EN_GB]: Currency.GBP,
    [TranslationLanguage.EN_US]: Currency.USD,
    [TranslationLanguage.CS]: Currency.CZK,
    [TranslationLanguage.SK]: Currency.EUR,
};

export const languageCountryMap: Partial<Record<TranslationLanguage, ComponentType>> = {
    [TranslationLanguage.EN_GB]: Gb,
    [TranslationLanguage.EN_US]: Us,
    [TranslationLanguage.CS]: Cz,
    [TranslationLanguage.SK]: Sk,
    // [Language.FR]: Fr,
    // [Language.DE]: De,
    // [Language.IT]: It,
    // [Language.ES]: Es,
    // [Language.PL]: Pl,
    // [Language.RU]: Ru,
    // [Language.PT]: Pt,
    // [Language.NL]: Nl,
    // [Language.HU]: Hu,
    // [Language.FI]: Fi,
    // [Language.DA]: Dk,
    // [Language.NO]: No,
    // [Language.SV]: Se,
    // [Language.EL]: Gr,
    // [Language.RO]: Ro,
    // [Language.BG]: Bg,
    // [Language.HR]: Hr,
    // [Language.SL]: Si,
    // [Language.LT]: Lt,
    // [Language.LV]: Lv,
    // [Language.ET]: Ee,
    // [Language.UK]: Ua,
    // [Language.CA]: Ca,
    // [Language.SR]: Rs,
    // [Language.MK]: Mk,
    // [Language.BS]: Ba,
    // [Language.IS]: Is,
    // [Language.BE]: Be,
    // [Language.AL]: Al,
    // [Language.CY]: Cy,
    // [Language.GA]: Ga,
    // [Language.GL]: Gl,
    // [Language.MT]: Mt,
    // [Language.TR]: Tr,
};

export const FALLBACK_LANGUAGE = TranslationLanguage.EN_GB;
